/* src/app/account/user-settings/user-terms-conditions/user-terms-conditions.component.scss */
/*# sourceMappingURL=user-terms-conditions.component.css.map */
